import { LoadingOutlined } from '@ant-design/icons';
import { Alert as AntAlert } from 'antd';
import styled from 'styled-components';
import { colors } from 'theme';

export const HyperLinkDiv = styled.div`
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

export const ErrorGenerateDocument = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    color: ${colors.lightRed};
`;

export const Alert = styled(AntAlert)`
    margin-top: 1.5rem;
    width: 100%;
`;

export const LoadingDocuments = styled(LoadingOutlined)`
    font-size: 2.5rem;
    margin-left: 1rem;
    margin-top: 6px;
`;
